import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export interface ThumbsDownFeedbackPayload {
  issueKind: "Response Issue" | "Display Issue" | "Other";
  description: string;
  message?: string;
  response?: string;
  messageId?: string;
  leagueContext?: string;
  shareUrl?: string;
  client?: string;
  currentVersion?: string;
  deviceModel?: string;
  calculatorSettings?: string;
}

export const sendThumbsDownFeedback = async (accessAuthToken: string, payload: ThumbsDownFeedbackPayload): Promise<{ success: boolean }> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/feedback/thumbs-down`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const message = errorData.message || "Failed to send feedback. Please try again.";
    showErrorToast(message);
    throw new Error(message);
  }

  return response.json();
};
